module.exports = __webpack_public_path__ + "dce4194a3c57c632f67fdd574268c1f3.png";